import { ISwodocArticleData } from '@alberta/konexi-shared';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { InstitutionAttributeConfigService } from 'src/app/shared/services/tenant-config/institution-attribute-config.service';

@Component({
  selector: 'swodoc-node-article-data',
  templateUrl: 'swodoc-node-article-data.html',
  providers: [InstitutionAttributeConfigService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeArticleData implements OnInit {
  @Input()
  node: any;

  get articles() {
    return this.node?.responses[0]?.value as ISwodocArticleData[];
  }

  set articles(value) {
    this.node.responses[0].value = value;
  }

  get TemplateNodeTitle() {
    return this.node?.title as string;
  }

  public articleExpanded = false;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  async ngOnInit() {
    this.node.mandatory = true;

    this._changeDetectorRef.markForCheck();
  }

  public toggleShowMore() {
    this.articleExpanded = !this.articleExpanded;
  }
}
